import { render, staticRenderFns } from "./NinthComponent.vue?vue&type=template&id=f44c02fc"
import script from "./NinthComponent.vue?vue&type=script&lang=js"
export * from "./NinthComponent.vue?vue&type=script&lang=js"
import style0 from "./NinthComponent.vue?vue&type=style&index=0&id=f44c02fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports